import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import { useDataProvider, useTranslate, Loading, usePermissions } from 'react-admin';
import { useHistory, Link } from 'react-router-dom';
import TextField from '../CustomizedUIs/CustomTextFiled';
import { red, pink } from '@material-ui/core/colors';
import SelectBoxFilter from '../common/select-box-filter';
import LoadingSave from '../common/loading-page';
import { ArrowBack, Refresh, PowerSettingsNew, NotificationsActive, AssignmentOutlined } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';
import { IconButton as IconButtonCustom } from '../common/button';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { lightBlue, grey } from '@material-ui/core/colors';
import DialogListRoom from './dialog-list-room';
import Snackbar from '../common/snackbar';
import DialogListFirmWare from './dialog-list-firmware';
import TextButton from '../CustomizedUIs/TextButton';

const bgColorError = pink['50'];
const textColorError = red['700'];

const TYPE_ACTION_KEY = {
    REBOOT: 'REBOOT',
    TURNOFF: 'TURNOFF',
    MESSAGE: 'MESSAGE',
    ASSIGNTOROOM: 'ASSIGNTOROOM',
    ACTIVATE: 'ACTIVATE'

}

const useStyles = makeStyles(theme => ({
    boxBorder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    textValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '12px',
        top: '10px'
    },
    iconButton: {
        margin: 'auto',
        borderRadius: '10px',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '8px'
    },
    removeIcon: {
        borderRadius: '10px',
        color: '#237fc2',
        backgroundColor: '#c1e5fa',
        padding: 4
    },
    buttonBoxSave: {
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingRight: 20,
        marginLeft: 'auto',
    },
    buttonBoxSaveBottom: {
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingRight: 20,
        marginLeft: 'auto',
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}));


const FormUpdate = ({ isEdit, ...props }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const { permissions, loaded } = usePermissions();
    const history = useHistory();
    const [device, setDevice] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [messageError, setMessageError] = useState('')
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [listDevice, setListDevice] = useState([]);
    const [profile, setProfile] = useState('')
    const [listTvModel, setListTvModel] = useState([])
    const [tvModel, setTvModel] = useState('')
    const [listDisplayMode, setListDisplayMode] = useState([])
    const [displayMode, setDisplayMode] = useState('')
    const [listResolution, setListResolution] = useState([])
    const [resolution, setResolution] = useState('')
    const [ShowSnackbarAssign, setShowSnackbarAssign] = useState(false);

    const [textValue, setTextValue] = useState({
        parental: '',
        alias: '',
        ipAddress: '',
        macAddress: '',
        macAddressSecondary: '',
        serialNumber: '',
        name: '',
        tvModel: '',
        firmware: ''
    })
    const [error, setError] = useState({
        name: { status: device.id ? false : true, message: '' },
        ipAddress: { status: device.id ? false : true, message: '' },
        macAddress: { status: device.id ? false : true, message: '' },
        macAddressSecondary: { status: device.id ? false : true, message: '' },
        serialNumber: { status: device.id ? false : true, message: '' },
        tvModel: { status: device.id ? false : true, message: '' },
    });
    const [dialogAssignment, setDialogAssignment] = useState({
        open: false,
        listDevices: []
    });
    const [dialogFirmWare, setDialogFirmWare] = useState({
        open: false,
        listDevices: []
    });
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onChangTextValue = (prop) => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0) {
                setError({
                    ...error, [prop]: value.length === 0 ? {
                        status: true, message: translate('pos.messages.required')
                    } : { status: false, message: '' }
                })
            }
            else {
                setError({
                    ...error, [prop]:
                        { status: false, message: '' }
                })
            }
        }
    }

    const onCreate = () => {
        setSaving(true);
        dataProvider('CREATE', 'device', {
            data: {
                parentalControlAge: parseInt(textValue.parental),
                alias: textValue.alias,
                ipAddress: textValue.ipAddress,
                id: textValue.macAddress,
                macAddressSecondary: textValue.macAddressSecondary,
                serialNumber: textValue.serialNumber,
                profile: profile ? profile.id : null,
                tvModel: tvModel ? tvModel.id : null,
                displayMode: displayMode ? displayMode.id : null,
                name: textValue.name,
                resolution: resolution ? resolution.id : null,
                status: false,
                firmware: textValue.firmware,
            }
        }).then(() => {
            goBackToList();
        }).catch(({ message }) => {
            setSaving(false);
            setMessageError(translate(message));
        });
    }


    const onEdit = () => {
        setSaving(true)
        dataProvider('UPDATE', 'device', {
            id: device.id,
            data: {
                parentalControlAge: parseInt(textValue.parental),
                alias: textValue.alias,
                profile: profile ? profile.id : null,
                displayMode: displayMode ? displayMode.id : null,
                name: textValue.name,
                resolution: resolution ? resolution.id : null,
                status: false
            }
        }).then(() => {
            goBackToList();
        }).catch(({ message }) => {
            setSaving(false);
            setMessageError(translate(message));
        });
    }


    const getListDevice = () => {
        dataProvider('GET_LIST', "device-profile", {
            filter: {},
            pagination: {
                page: 1,
                perPage: 100
            },
            sort: {
                field: 'id',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setLoading(false);
            setListDevice(data)
        }).catch(error => {
            console.error('GET LIST DEVICE ERROR:', error);
        });
    }

    const getDevice = () => {
        dataProvider('GET_ONE', `device?id=${device.id}`
        ).then(({ data }) => {
            setLoading(false);
            setTextValue({
                parental: data.parentalControlAge,
                alias: data.alias,
                ipAddress: data.ipAddress,
                macAddress: data.id,
                macAddressSecondary: data.macAddressSecondary,
                serialNumber: data.serialNumber,
                name: data.name,
                tvModel: data.tvModel.name,
                firmware: data.firmware
            })
            setDevice(data);
            setProfile(data.profile)
            setDisplayMode(data.displayMode)
            setResolution(data.resolution)
        }).catch(error => {
            console.error('GET DEVICE ERROR:', error);
            // goBackToList();
        });
    }


    const getListTvModel = () => {
        dataProvider('GET_LIST', "device-tvmodel", {
            filter: {},
            pagination: {
                page: 1,
                perPage: 10
            },
            sort: {
                field: 'id',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setLoading(false);
            setListTvModel(data)
        }).catch(error => {
            console.error('GET TvModel ERROR:', error);
        });
    }
    const getListDisplayMode = () => {
        dataProvider('GET_LIST', "device-displaymode", {
            filter: {},
            pagination: {
                page: 1,
                perPage: 10
            },
            sort: {
                field: 'id',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setLoading(false);
            setListDisplayMode(data)
        }).catch(error => {
            console.error('GET DisplayMode ERROR:', error);
        });
    }
    const getListResolution = () => {
        dataProvider('GET_LIST', "device-resolution", {
            filter: {},
            pagination: {
                page: 1,
                perPage: 10
            },
            sort: {
                field: 'id',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setLoading(false);
            setListResolution(data)
        }).catch(error => {
            console.error('GET Resolution ERROR:', error);
        });
    }

    const goBackToList = () => {
        history.push({
            pathname: '/ClientDevice'
        });
    }


    const onChangeProfile = (value) => {
        setProfile(value)
    }

    const onChangeTvModel = (value) => {
        setTvModel(value)
    }

    const onChangeDisplayModel = (value) => {
        setDisplayMode(value)
    }

    const onChangeResolution = (value) => {
        setResolution(value)
    }

    const handleDisable = () => {
        if (textValue.ipAddress === '' || textValue.macAddress === '' || textValue.macAddressSecondary === '' || textValue.serialNumber === '') return true;
        if (saving) return true;
        if (!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)) return true;
        return false
    }

    useEffect(() => {
        const deviceId = props.match.params.id;
        if (deviceId) {
            device.id = deviceId;
            getDevice();
        } else {
            setLoading(false);
        }
    }, []);

    const onActionClick = (key) => {
        switch (key) {
            case TYPE_ACTION_KEY.UPDATE:
                if (device)
                    onOpenFirmWare([device])
                break;
            case TYPE_ACTION_KEY.ASSIGNTOROOM:
                if (device)
                    onOpenAssignment([device]);
                break;
            default:
                dataProvider('CREATE', "rebootDevices", {
                    data: {
                        key: key.toLowerCase(),
                        deviceId: props.match.params.id
                    }
                }).then(({ data }) => {
                    console.log('send socket success:', data);
                }).catch(error => {
                    console.error('send socket error:', error);
                })
                break;
        }
    }

    const onOpenAssignment = (listDevices) => {
        setDialogAssignment({
            open: true,
            listDevices
        });
    }
    const onOpenFirmWare = (listDevices) => {
        setDialogFirmWare({
            open: true,
            listDevices
        });
    }

    const onCloseDialogAssign = () => {
        setDialogAssignment({
            open: false,
            listDevices: []
        });
    }
    const onCloseDialogFirmWare = () => {
        setDialogFirmWare({
            open: false,
            listDevices: []
        });
    }

    const hiddenActionButton = () => {
        if (!permissions.functionAction.find(value => value.function === 'Unit' && value.isUpdate)) {
            if (permissions.functionAction.find(value => value.function === 'Client devices' && value.isRead)) {
                if (!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)) {
                    return true
                }
                return false
            }
            else return true
        }
        else {
            if (permissions.functionAction.find(value => value.function === 'Client devices' && value.isRead)) {
                if (!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)) {
                    return true
                }
                return false
            }
            else return true
        }
    }

    useEffect(() => {
        getListDevice()
        getListTvModel()
        getListDisplayMode()
        getListResolution()
    }, [])

    useEffect(() => {
        if (ShowSnackbarAssign === true) {
            setTimeout(() => {
                setShowSnackbarAssign(false);
            }, 6000);
        }
    }, [ShowSnackbarAssign]);


    if (!loaded) return null
    if (loading) return <Loading />
    return (
        <Box width='80%' m='auto'>
            <LoadingSave show={saving} />
            <Box className={!permissions.functionAction.find(value => value.function === 'Client devices' && (value.isUpdate || value.isRead)) ? classes.disabled : classes.enabled}>
                <Box my={5} width={300} display='flex' component={Link} to={'/ClientDevice'} style={{ textDecoration: 'none' }}>
                    <Box display='flex' mr={2}>
                        <IconButton className={classes.iconButton}>
                            <ArrowBack />
                        </IconButton>
                    </Box>
                    <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.devices.backDevice`)}</Typography>
                </Box>
            </Box>
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    <Snackbar
                        show={ShowSnackbarAssign}
                        message={translate('pos.devices.SnackbarAssign')}
                        onClose={() => setShowSnackbarAssign(false)}
                    />
                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{isEdit ? translate(`pos.channels.editting`) + device.name : translate(`pos.devices.addDevice`)}</Typography>
                    <Box my={2} className={classes.buttonBoxSave} width={650}>
                        <Box className={hiddenActionButton() ? classes.disabled : classes.enabled}>

                            <IconButtonCustom
                                label={translate('pos.devices.turnOff')}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.TURNOFF)}
                                style={{ marginRight: 10 }}
                                startIcon={<PowerSettingsNew />}
                            />
                            <IconButtonCustom
                                label={translate('pos.devices.reboot')}
                                style={{ marginRight: 10 }}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.REBOOT)}
                                startIcon={<Refresh />}
                            />
                            <IconButtonCustom
                                label={translate('pos.devices.notification')}
                                style={{ marginRight: 10 }}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.MESSAGE)}
                                startIcon={<NotificationsActive />}
                            />
                            <IconButtonCustom
                                label={translate('pos.devices.assignToRoom')}
                                style={{ marginRight: 10 }}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.ASSIGNTOROOM)}
                                startIcon={<AssignmentOutlined />}
                            />

                        </Box>
                    </Box>
                    <Box my={1} className={classes.buttonBoxSaveBottom} width={650}>
                        <Box className={hiddenActionButton() ? classes.disabled : classes.enabled}>
                            <IconButtonCustom
                                label={translate('pos.devices.activate')}
                                style={{ marginRight: 10 }}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.ACTIVATE)}
                                startIcon={<DoneIcon />}
                            />
                            <IconButtonCustom
                                label={translate('pos.devices.firmwareUpdate')}
                                style={{ marginRight: 10 }}
                                onClick={() => onActionClick(TYPE_ACTION_KEY.UPDATE)}
                                startIcon={<SystemUpdateAltIcon />}
                            />
                        </Box>
                    </Box>
                    <Box>
                        {
                            messageError != "" && (
                                <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                    <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messageError}</Typography>
                                </Box>
                            )
                        }
                        <Box my={2}>
                            <TextField
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                required
                                id='name'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.name`)}
                                onBlur={() => { validate('name', textValue.name) }}
                                value={textValue.name}
                                onChange={onChangTextValue('name')}
                                error={error.name.message !== '' && error.name.status}
                                helperText={error.name.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.name`)}
                                    content={translate(`pos.devices.contentName`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <SelectBoxFilter
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                data={listDevice}
                                label={translate(`pos.devices.profile`)}
                                value={profile ? profile.name : ''}
                                onChange={(value) => onChangeProfile(value)}
                                error={error.name.message !== '' && error.name.status}
                                helperText={error.name.message}
                                keyName='name'
                                placeholder={translate('pos.devices.searchProfile')}
                            />
                        </Box>
                        <Box my={2}>
                            <Box my={2}>{
                                device.id ? <TextField
                                    disabled={device.id ? true : false}
                                    id='model'
                                    style={{ width: 500 }}
                                    label={translate(`pos.devices.model`)}
                                    value={textValue.tvModel}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.devices.model`)}
                                        content={translate(`pos.devices.contentModel`)}
                                        icon={<b>?</b>}
                                    />} /> :
                                    <SelectBoxFilter
                                        data={listTvModel}
                                        label={translate(`pos.devices.model`)}
                                        value={tvModel ? tvModel.name : ''}
                                        onChange={(value) => onChangeTvModel(value)}
                                        keyName='name'
                                        placeholder={translate('pos.devices.searchProfile')}
                                    />
                            }
                            </Box>

                        </Box>
                        <Box my={2}>
                            <SelectBoxFilter
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                data={listDisplayMode}
                                label={translate(`pos.devices.displayMode`)}
                                value={displayMode ? displayMode.name : ''}
                                onChange={(value) => onChangeDisplayModel(value)}
                                keyName='name'
                                placeholder={translate('pos.devices.searchDisplayMode')}
                            />
                        </Box>
                        <Box my={2}>
                            <SelectBoxFilter
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                data={listResolution}
                                label={translate(`pos.devices.resolution`)}
                                value={resolution ? resolution.name : ''}
                                onChange={(value) => onChangeResolution(value)}
                                keyName='name'
                                placeholder={translate('pos.devices.searchResolution')}
                            />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                id='parental'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.Parental`)}
                                onBlur={() => { validate('parental', textValue.parental) }}
                                value={textValue.parental}
                                onChange={onChangTextValue('parental')}
                                // error={error.name.message !== '' && error.name.status}
                                type="number"
                                // helperText={error.name.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.Parental`)}
                                    content={translate(`pos.devices.contentParental`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={!permissions.functionAction.find(value => value.function === 'Client devices' && value.isUpdate)}
                                id='alias'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.Alias`)}
                                onBlur={() => { validate('parental', textValue.alias) }}
                                value={textValue.alias}
                                onChange={onChangTextValue('alias')}
                                // error={error.name.message !== '' && error.name.status}
                                // helperText={error.name.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.Alias`)}
                                    content={translate(`pos.devices.contentAlias`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={device.id ? true : false}
                                required
                                id='ipAddress'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.ipAddress`)}
                                onBlur={() => { validate('ipAddress', textValue.ipAddress) }}
                                value={textValue.ipAddress}
                                onChange={onChangTextValue('ipAddress')}
                                error={error.ipAddress.message !== '' && error.ipAddress.status}
                                helperText={error.ipAddress.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.ipAddress`)}
                                    content={translate(`pos.devices.contentIPAddress`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={device.id ? true : false}
                                required
                                id='macAddress'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.macAddress`)}
                                onBlur={() => { validate('macAddress', textValue.macAddress) }}
                                value={textValue.macAddress}
                                onChange={onChangTextValue('macAddress')}
                                error={error.macAddress.message !== '' && error.macAddress.status}
                                helperText={error.macAddress.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.macAddress`)}
                                    content={translate(`pos.devices.contentMacAddress`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={device.id ? true : false}
                                required
                                id='macAddressSecondary'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.macAddressSecondary`)}
                                onBlur={() => { validate('macAddressSecondary', textValue.macAddressSecondary) }}
                                value={textValue.macAddressSecondary}
                                onChange={onChangTextValue('macAddressSecondary')}
                                error={error.macAddressSecondary.message !== '' && error.macAddressSecondary.status}
                                helperText={error.macAddressSecondary.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.macAddressSecondary`)}
                                    content={translate(`pos.devices.contentMacAddressSecondary`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={device.id ? true : false}
                                required
                                id='firmware'
                                style={{ width: 500 }}
                                label={'Firmware version'}
                                value={textValue.firmware}
                                onChange={onChangTextValue('firmware')}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={'Firmware'}
                                    content={'This is firmware version of devices'}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                disabled={device.id ? true : false}
                                required
                                id='serialNumber'
                                style={{ width: 500 }}
                                label={translate(`pos.devices.serialNumber`)}
                                onBlur={() => { validate('serialNumber', textValue.serialNumber) }}
                                value={textValue.serialNumber}
                                onChange={onChangTextValue('serialNumber')}
                                error={error.serialNumber.message !== '' && error.serialNumber.status}
                                helperText={error.serialNumber.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.serialNumber`)}
                                    content={translate(`pos.devices.contentSerialNumber`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>

                        <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                            <Box className={!permissions.functionAction.find(value => value.function === 'Client devices' && (value.isUpdate || value.isRead)) ? classes.disabled : classes.enabled}>
                                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/ClientDevice" }} />
                            </Box>
                            <Button disabled={handleDisable()} style={{ padding: 8 }} variant='contained' color='primary' onClick={device.id ? onEdit : onCreate}>
                                {
                                    device.id ? translate(`pos.common.save`) : translate(`pos.common.create`)
                                }
                            </Button>
                        </Box>

                        <DialogListRoom
                            open={dialogAssignment.open}
                            onClose={onCloseDialogAssign}
                            listDevices={dialogAssignment.listDevices}
                            getListDevices={getListDevice}
                            setShowSnackbarAssign={setShowSnackbarAssign}
                        />
                        <DialogListFirmWare
                            open={dialogFirmWare.open}
                            onClose={onCloseDialogFirmWare}
                            listDevices={dialogFirmWare.listDevices}
                            getListDevices={getListDevice}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

FormUpdate.propTypes = {
    isEdit: PropTypes.bool
};

export default FormUpdate